import ADB from '../../../libs/MediaSDK';

import { allowLog } from '../../globals';

const { MediaConfig } = ADB;
let mediaConfig = null;
const init = () => {
    if(mediaConfig != null) {
        return;
    }
    const { s_md } = window;

    //let appMeasurement = new MediaAnalyticsAppMeasurement(s_account);
    const CONFIG = {
        //APP_VERSION: akamai.amp.AMP.VERSION,
        TRACKING_SERVER: s_md.account === "webmddev" ? "webmd-stage.hb-api.omtrdc.net" : "webmd.hb-api.omtrdc.net", //document.location.host,//`webmd.sc.omtrdc.net`,
        CHANNEL: s_md.prop47 || "",
        //SDK: `Heartbeats V-${ADB.Media.version}`,
        OVP: "Akamai"
    }
    const { TRACKING_SERVER, CHANNEL, OVP } = CONFIG;

    mediaConfig = new MediaConfig();
    mediaConfig.trackingServer = TRACKING_SERVER;
    mediaConfig.playerName = "media-amp";
    mediaConfig.channel = CHANNEL;
    mediaConfig.debugLogging = allowLog;
    mediaConfig.appVersion = VERSION;
    mediaConfig.ssl = true;
    mediaConfig.ovp = OVP;

    ADB.Media.configure(mediaConfig, s_md);
}

const { s_account } = window;



export const getMediaConfig = async () => {
    if (mediaConfig != null) {
        return mediaConfig;
    }
    else if (typeof s_account === 'undefined' || window.s_md.visitor == null) {
        const promise = new Promise((resolve, reject) => {
            function handleVisitorIdSet(event) {
                console.log("handleVisitorIdSet event:", event);
                document.removeEventListener("visitorIdSet", handleVisitorIdSet);
                init();
                resolve(mediaConfig);
            }

            document.addEventListener("visitorIdSet", handleVisitorIdSet, true);
        });

        return promise;


    }
    else {
        init();
        return mediaConfig;
    }
}

export default mediaConfig;
